module.exports = __webpack_public_path__ + "static/media/EnergiaImgEng.5d8a724b.png";